import { FC, JSX } from 'react'
import { BillingMethodAvatar, BillingMethodAvatarType } from './Avatar'

export const BillingMethod: FC & BillingMethodAvatarType = (): JSX.Element => (
  <></>
)

BillingMethod.Avatar = BillingMethodAvatar
